import React from 'react';

function Floppy({ size, stroke, strokeWidth, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={stroke}
      strokeWidth={strokeWidth}
      {...otherProps}
    >
      <g stroke="currentColor" strokeWidth={strokeWidth} fill="none">
        <path d="M18.222 20H5.778A1.778 1.778 0 0 1 4 18.222V5.778C4 4.796 4.796 4 5.778 4h9.778L20 8.444v9.778c0 .982-.796 1.778-1.778 1.778z" />
        <path d="M17 20v-7H8v7M8 4v4h7" />
      </g>
    </svg>
  );
}

export default Floppy;
